module.exports = __webpack_public_path__ + "static/7-06688987f08584228fbd24a94b697bb8.jpg";